<template>
  <StateRenderer :lines="lines" v-bind="periodsState">
    <slot v-bind="periodsState" />
  </StateRenderer>
</template>

<script>
import { mapState } from 'vuex'
import StateRenderer from '@/components/StateRenderer'

export default {
  name: 'PeriodsFetcher',
  components: { StateRenderer },
  props: {
    lines: {
      type: Number,
      default: 1
    },
    storeId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...mapState('multiStoresSse', ['toyUpdates']),

    // converte objeto { storeId: data } em array [{ storeId, data }, ...]
    rawStores() {
      return Object.entries(this.toyUpdates).map(([storeId, data]) => ({
        storeId,
        data
      }))
    },

    // filtra somente os períodos da storeId atual
    filteredPeriods() {
      const entry = this.rawStores.find(
        ({ storeId }) => String(storeId) === String(this.storeId)
      )
      return entry?.data.periods ?? []
    },

    // formato esperado por StateRenderer: { loading, error, data }
    periodsState() {
      return {
        loading: false,
        error: null,
        data: this.filteredPeriods
      }
    }
  }
}
</script>
